import React from 'react';
import { Icon, StackPanel, Typography } from '@agilepoint/wat-react-ux';
import { Localize } from '@agilepoint/wat-react';
import { useNavigateManager } from 'lib/hooks';
import styled from 'styled-components';


interface ILogoProps {
    isMenuCollapsed: boolean;
}

const StyledStackPanel = styled(StackPanel)<{ isMenuCollapsed: boolean }>`
    padding: 12px 12px 0px;
    padding-left: ${props => (props.isMenuCollapsed ? '20px' : '12px')};
`;

const Heading = styled(Typography.H5)`
    color: ${props => props.theme.semantics.palette.black};
`;

export function Logo(props: ILogoProps) {
    const { isMenuCollapsed } = props;
    const history = useNavigateManager();

    const logoClickHandler = React.useCallback(() => {
        history.push('/dashboard');
    }, [history]);

    return (
        <StyledStackPanel width="calc(100% - 24px)" isMenuCollapsed={isMenuCollapsed} orientation='horizontal' gap="12" onClick={logoClickHandler} justifyContent="flex-start" alignment="center">
            <Icon iconName='ap-agilepoint-logo.solid' iconSize='28' />
            {isMenuCollapsed ? <></> :
                <Heading><Localize translate="modules.maaTitle.mobileAppAcceleratorTitle" /> </Heading>}
        </StyledStackPanel>
    );
}
